import { IBooleanCondition, isStaticActive } from '../../inputs';
import { conditionResultToBoolean } from '../../schema/widgets/hooks/conditionResultToBoolean';
import { IHydrationContext } from '../IHydrationContext';
import { hydrateExpressionValue } from './hydrateExpressionValue';

export function hydrateBooleanCondition(
  context: IHydrationContext,
  name: string,
  condition: IBooleanCondition | null | undefined,
) {
  if (isStaticActive(condition)) {
    return true;
  }

  const result = hydrateExpressionValue(
    context,
    name,
    condition?.type === 'expression' ? condition.expression : null,
  );
  return conditionResultToBoolean(condition, result);
}
